/** @format */

const ErrorMessage = ({ error, classes = "f-13" }) => {
  if (!error) return null;
  return (
    <div
      className={`text-danger d-flex flex-row justify-content-start ${classes} my-2`}
    >
      {error}
    </div>
  );
};

export default ErrorMessage;
